import Prompt from 'Components/tasks/Prompt/Prompt'
import { SingleValueDataType } from 'Types/Tasks.types'
import { BlockComponentFactory } from 'shared/express-interface/blocks-core/BlockFactory'
import { useTaskContext } from 'Contexts/TaskContext'

export type PromptBlockProps = {
    title?: string
    content?: SingleValueDataType<'STRING'>
}

export const PromptBlockComponent = BlockComponentFactory.createBlockComponent<PromptBlockProps>(
    props => {
        const taskContext = useTaskContext()
        const { title, content } = props

        const inputContent =
            taskContext.getInputDetails().data.data.conversation_nodes?.at(-1)?.content.data ??
            ({
                value_type: 'STRING',
                value:
                    taskContext.getInputDetails().data.data.main_info?.value?.prompt_instruction ??
                    '',
            } as SingleValueDataType<'STRING'>)
        const taskAdditionalInfo = taskContext.taskAdditionalInfo

        return (
            <Prompt
                title={title ?? 'INPUT'}
                content={content ?? inputContent}
                contextType={taskContext.studio.studioConfig.context.type}
                taskInfo={taskAdditionalInfo}
            />
        )
    }
)
